import React, { useState } from 'react';
import { ROUTES } from 'global/constants';
import { NavLink } from 'react-router-dom';
import { logout } from 'auth/actions';
import { useSelector } from 'react-redux';
import { getUsername } from 'auth/selectors';
import { WrappedMessage } from 'utils';
import messages from '../../../displayMessages';
import authMessages from 'ui/components/displayMessages';
import { Button, Icon, LoggedInMenu } from 'ui/components';
import { redirectToLogin, redirectToLxSignUp } from 'auth/actions';
import MobileNavSideBar from './MobileNavSideBar';

const Navbar: React.FC = () => {
  const loggedInUsername = useSelector(getUsername);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const logoElement = (testId: string) => (
    <div className='navbar__icon' data-testid={testId}>
      <img
        alt='CareerXplorer-logo'
        title='CareerXplorer-logo'
        src='/assets/images/career-explorer/career-xplorer-logo-navy.svg'
      />
    </div>
  );

  return (
    <nav className='navbar-career'>
      <div className='navbar-content'>
        <div className='mobile-menu-items'>
          <div
            onClick={() => setSidebarOpen(!sidebarOpen)}
            data-testid='mobile-hamburger'
          >
            <Icon zoom='2em' name='grabber' fill='#497595' />
          </div>
          <div className='logo-wrapper'>{logoElement('mobile-logo')}</div>
        </div>
        <div className='menu-items'>
          {logoElement('desktop-logo')}

          <NavLink
            to={`${ROUTES.CareerExplorer.CAREER_HOME_URL}?isInternal=true`}
            className='menu-option'
            activeClassName='menu-option__active'
          >
            <WrappedMessage message={messages.exploreCareersNavOption} />
          </NavLink>
          <NavLink
            to={`${ROUTES.CareerExplorer.FIELD_HOME_URL}?isInternal=true`}
            className='menu-option'
            isActive={(match) => !!match}
            activeClassName='menu-option__active'
          >
            <WrappedMessage message={messages.exploreFieldsNavOption} />
          </NavLink>
        </div>
        {loggedInUsername ? (
          <div className='menu-items'>
            <NavLink
              to={ROUTES.CareerExplorer.SAVED_CAREERS}
              className='menu-option'
              activeClassName='menu-option__active'
            >
              <WrappedMessage message={messages.myCareerNavOption} />
            </NavLink>
            <LoggedInMenu
              className='hide-mobile'
              onLogOut={logout}
              username={loggedInUsername}
              variation='ce'
            />
          </div>
        ) : (
          <div className='career-logged-out-menu'>
            <button
              className='login-btn'
              onClick={() => {
                redirectToLogin();
              }}
            >
              <WrappedMessage message={authMessages.uiSignIn} />
            </button>
            <button
              className='signup-btn'
              onClick={() => {
                redirectToLxSignUp();
              }}
            >
              <WrappedMessage message={authMessages.uiSignUp} />
            </button>
          </div>
        )}
      </div>
      {sidebarOpen && (
        <MobileNavSideBar
          setSidebarOpen={() => setSidebarOpen(false)}
          sidebarOpen={sidebarOpen}
        />
      )}
    </nav>
  );
};

export default Navbar;
